// extracted by mini-css-extract-plugin
module.exports = {"maxWidthSmallScreenDesktop":"960px","inputWrapper":"textInput_inputWrapper__E_QDO","inputWrapper__disabled":"textInput_inputWrapper__disabled__38Pnh"};